import corporateInvoice from "./corporateInvoice.component";
import corporateInvoiceUrls from "./corporateInvoice.urls";
import CorporateInvoiceTransforms from "./corporateInvoice.transforms";

const corporateInvoiceModule = angular
  .module("app.components.corporateInvoice", [])
  .component("corporateInvoicePage", corporateInvoice)
  .service("CorporateInvoiceTransforms", CorporateInvoiceTransforms)
  .config(corporateInvoiceUrls);

export default corporateInvoiceModule;



// WEBPACK FOOTER //
// ./src/pages/corporateInvoice/corporateInvoice.module.js